import type { DataLayerEvent } from '@rover/types/src/DataLayerEvent';

type defaultEventParams = {
  cookieId?: string;
  personId?: string;
  source: string;
};

export const RoverProtectEvents = {
  SearchClick: (params: defaultEventParams): DataLayerEvent => {
    return { event: 'roverprotect-search-click', ...params };
  },
  PageView: (params: defaultEventParams): DataLayerEvent => {
    return { event: 'roverprotect-page-view', ...params };
  },
  LearnMoreGuaranteeUrl: (params: defaultEventParams): DataLayerEvent => {
    return { event: 'roverprotect-guarantee-click', ...params };
  },
  ContactSupport: (params: defaultEventParams): DataLayerEvent => {
    return { event: 'roverprotect-contact-support-click', ...params };
  },
};
